import {
  INDIVIDUAL_OBJECTIVE_FETCHING,
  INDIVIDUAL_OBJECTIVE_SUCCESS,
  INDIVIDUAL_OBJECTIVE_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case INDIVIDUAL_OBJECTIVE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case INDIVIDUAL_OBJECTIVE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case INDIVIDUAL_OBJECTIVE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
